import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
import 'rxjs/add/operator/filter';
import { QuestionnaireService } from "../services/questionnaire.service";

@Component({
	selector: 'app-step-indicator',
	templateUrl: './step-indicator.component.html',
	styleUrls: ['./step-indicator.component.scss']
})
export class StepIndicatorComponent implements OnInit {
	public currentStep;
	private router1;
	private states = {
		"user-details": 1,
		"cycle-details": 2,
		"user-more-details": 3,
		"borrowers-details": 4,
		"liabilities": 5,
		"financing-sources": 6
	};
	public statesKeys = Object.keys(this.states);

	constructor(
		router: Router, 
		route: ActivatedRoute, 
		private _router: Router, 
		private questionnaireService: QuestionnaireService
	) {
		this.router1 = _router;
		this._router.events
			.filter(event => event instanceof NavigationEnd)
			.subscribe((event: any) => {
				this.currentStep = questionnaireService.getActiveStep();
			});
	}

	ngOnInit() {
		this.currentStep = this.questionnaireService.getActiveStep();
	}

	isStepCompleted(stepId: string) {
		return this.questionnaireService.getStepByID(stepId).completed;
	}

	isStepReachble(stepId: string) {
		return this.questionnaireService.getStepByID(stepId).reachable;
	}

	getStepRouterLink(indx:number){
		let lnk="/questionnaire/" + this.statesKeys[indx] + "/";
		let restorePoint = this.questionnaireService.getRestorePoint();

		if(restorePoint.step && restorePoint.step.stepName === this.statesKeys[indx]){
			//if step with restore point, resume it
			lnk+=restorePoint.questionID;
		}else{
			lnk+="all";
		}

		return lnk;
	}
}



// WEBPACK FOOTER //
// ./src/app/step-indicator/step-indicator.component.ts